export default __webpack_public_path__ + "static/media/Spinner.0a5d21b6.svg";